import React from "react";

const PanStatusResponse = (props) => {
    return(<></>)
};

export default PanStatusResponse;
